import { useNavigate } from "react-router-dom";
import Button from "../../../component/Button";
import { isMobile } from "../../../utils/func";

export const Section3 = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col py-[120px] md:py-[160px] justify-center items-center md:gap-20 gap-[50px]"
      style={{
        backgroundImage:
          "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.9) 20%, rgba(255,255,255,0.6) 45%, rgba(255,255,255,0) 70%), url('/assets/images/effect/gradient.png')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex flex-col md:gap-8 gap-3">
        <span className="text-center font-bold text-[28px] md:text-[36px]">
          품 도입을 {isMobile() && <br />} 검토 중이신가요?
        </span>
        <span className="text-center font-normal text-[20px] md:text-[28px] text-[#4D4F58]">
          1:1 도입 상담 또는 품 소개서 {isMobile() && <br />} 확인으로 더 자세히 알아보세요
        </span>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-3 items-center w-full md:w-auto px-6 md:px-0">
        <Button
          id="btn-bottom-apply"
          size="sm"
          className="md:h-20 h-[58px] md:text-[20px] text-[16px] md:min-w-[256px]  w-full px-8 rounded-[70px] border-[3px] border-transparent
        [background-origin:border-box]
        [background-clip:padding-box,border-box]
        bg-[linear-gradient(#fff,#fff),linear-gradient(90deg,#0079FF_0%,#00FF44_56.09%,#FFC400_100%)]
        text-[#0079FF]"
          onClick={() => {
            navigate("/inquiry-form?type=adoption");
          }}
        >
          품 도입 문의
        </Button>

        <Button
          id="btn-bottom-doc"
          size={isMobile() ? "md" : "sm"}
          className="md:h-20 h-[58px] md:text-[20px] text-[16px] md:min-w-[256px] w-full rounded-[70px] px-8 bg-[#000]"
          onClick={() => {
            navigate("/inquiry-form?type=introduction");
          }}
        >
          소개자료 다운받기
        </Button>
      </div>
    </div>
  );
};
